// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"ddffe5bc","453":"96c35c25","796":"29edb6e1"}[chunkId] + ".chunk.js";
};